import React from 'react'
import NoData from "../../Components/NoData/noData";
import useBusinessDashboardHooks from './businessDashboard-hooks';
import Loading from '../../Components/Loading/loading';
import BusinesDashboardCard from '../../Components/Cards/BusinesDashboard/businesDashboardCard';
import CustomDialog from '../../Components/Dialog/customDialog';
import styles from './businesDashboard.module.scss';

const BusinessDashboard: React.FC = () => {
    const { navigate, t, myCompanies, isLoading,isDialogOpen,onCloseDialog,dialogComponent } = useBusinessDashboardHooks();
 
    return (
        <>
            {
                isLoading
                    ?
                    <Loading />
                    :
                    (
                        myCompanies!.length > 0
                            ?
                            <div className={styles.page}>
                                {
                                    myCompanies?.map((item) => {
                                        return (
                                            <BusinesDashboardCard
                                                key={item.id}
                                                data={item!}
                                            />
                                        )
                                    })
                                }
                                {/* <button onClick={() => navigate('/create_business')}>Create</button> */}
                            </div>
                            :
                            <NoData
                                withButton={true}
                                message={t('No_Data.Business')}
                                buttonTitle={t('Buttons.Create_Business')}
                                onPressButton={() => navigate('/create_business')}
                            />
                    )

            }
               <CustomDialog
                    open={isDialogOpen}
                    onClose={onCloseDialog}
                    children={dialogComponent}
                  />
        </>
    )
};

export default BusinessDashboard